<template>
  <el-container class="details-container">
    <el-header height="70px">
      <Navigation />
    </el-header>

    <el-main style="padding-top:70px;">
      <!-- 公司介绍 -->
      <Introduce />
      <!-- 品牌文化 -->
      <Culture />
      <!-- 健康责任 -->
      <Duty/>
      <!-- 荣誉资质 -->
      <Qualifications  />
      <!-- 美学中心 -->
      <Croe />
    </el-main>
    <el-footer style="padding:0;">
      <Footer style="background-color:#000000;" />
    </el-footer>
  </el-container>
</template>

<script>
// components
//common
import Navigation from '@/components/common/navigation/Navigation2.vue'
import Footer from '@/components/common/footer/Footer.vue'
import Introduce from '@/views/about/name/Introduce.vue'
import Culture from '@/views/about/name/Culture.vue'
import Duty from '@/views/about/name/Duty.vue'
import Qualifications from '@/views/about/name/Qualifications.vue'
import Croe from '@/views/about/name/Croe.vue'
export default {
  components: {
    Navigation,
    Footer,
    Introduce,
    Culture,
    Duty,
    Qualifications,
    Croe
  },
  compute:{

  },
  methods:{

  },
  mounted(){

  },
  watch:{

  }
}
</script>

<style lang='less' scoped>
.details-container {
  position: relative;
  .el-header {
    position: fixed;
    top: 0;
    z-index: 10000;
    left: 0;
    // transform: translate(-50%, 0%);
    width: 100%;
  }
  .el-main{
    padding: 0;
    overflow: hidden;
  }
}
.el-header {
  background-color: var(--color-background);
  display: flex;
    align-items: center;
}
// .about-qualifications{
//   height: 750px;
//   width: 100%;
//   background: url(../../assets/images/about/about4.png);
//   background-size: cover;
//   background-position: center;
//   .container{
//     display: flex;
//     .about-subject{
//       padding-top: 3rem;
//       .about-title{
//         display: inline-block;
//         font-weight: 500;
//         padding: 0.2rem;
//         border-bottom:1px #74b828 solid;
//         margin-bottom: 2rem;
//         color: #74b828;
//       }
//       .about-text{
//         color: #74b828;
//         margin-bottom: 2.6rem;
//       }
//       .about-item{
//         h1{
//           color: #fff;
//           line-height: 3rem;
//         }
//         p{
//           color: #74b828;
//           font-size: 1.4rem;
//           font-weight: 500;
//           line-height: 3rem;
//         }
//       }
//     }
//     .about-video{
//       padding-top: 8rem;
//       padding-left: 3rem;
//       img{

//       }
//       p{
//         color: #fff;
//       }
//     }
//   }
  
// }
// .about-croe{
//   height: 750px;
//   width: 100%;
//   background: #e5eeed;
//   display: flex;
//   align-items: center;
//   .container{

//     .about-title{
//         display: inline-block;
//         font-weight: 500;
//         padding: 0.2rem;
//         border-bottom:1px #74b828 solid;
//         margin-bottom: 2rem;
//         color: #74b828;
//       }
//     .train-box{
//       display: flex;
//       justify-content: space-between;
//       margin-bottom: 20px;
//       .train-card{
//         background: #fff;
//         width: 386px;
//         box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
//         .train-text{
//           padding: 0rem 1rem 0;
//           .p-color{
//             color: #23886c;
//             font-weight: 500;
//             font-size: 1.2rem;
//             line-height: 1rem;
//           }
//           p{
//             line-height: 1.6rem;
//           }
//         }
//       }
      
//     }
//   }
// }
@media only screen and (max-width: 786px) {
  .container{
      max-width: 786px;
      width: 100%;
      padding: 0 20px;
      overflow: hidden;
      .train-box{
        flex-direction: column;
      }
    }
}


</style>